import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import HeroSlider from '../../components/home/HeroSlider';
import { ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon, MapPinIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import logo from '../../assets/images/logo.jpeg';

// ─── GYM PHOTOS (exactly as per list) ─────────────────────────────────────────
import Fitneseqp1 from '../../assets/images/Fitneseqp1.png';
import fitneseqp2 from '../../assets/images/fitneseqp2.png';
import fitneseqp3 from '../../assets/images/fitneseqp3.png';
import fitneseqp4 from '../../assets/images/fitneseqp4.png';
import fitneseqp5 from '../../assets/images/fitneseqp5.png';
import fitneseqp6 from '../../assets/images/fitneseqp6.png';
import fitneseqp7 from '../../assets/images/fitneseqp7.png';
import fitneseqp8 from '../../assets/images/fitneseqp8.png';
import fitneseqp9 from '../../assets/images/fitneseqp9.png';
import fitneseqp10 from '../../assets/images/fitneseqp10.png';
import fitneseqp11 from '../../assets/images/fitneseqp11.png';
import fitneseqp12 from '../../assets/images/fitneseqp12.png';

// ─── SAUNA PHOTOS ─────────────────────────────────────────────────────────────
import saunaPic from '../../assets/images/sauna pic.png';
import saunaPic2 from '../../assets/images/sauna pic 2.png';
import saunaPic3 from '../../assets/images/sauna pic 3.png';

// ─── STEAM PHOTOS ─────────────────────────────────────────────────────────────
import steamRoom from '../../assets/images/steam room.png';

// ─── LOCKER PHOTOS ────────────────────────────────────────────────────────────
import lockers1 from '../../assets/images/lockers1.png';
import lockers2 from '../../assets/images/lockers2.png';

// ─── BATHROOM PHOTO ───────────────────────────────────────────────────────────
import bathroom from '../../assets/images/bathroom.png';

// ─── PCF STUDIO OUT ───────────────────────────────────────────────────────────
import pcfStudioOut from '../../assets/images/pcf studio out.png';
import studio1 from '../../assets/images/studio1.jpg';

// ─── NEW FACILITY IMAGES ──────────────────────────────────────────────────────
import facilityWashroom from '../../assets/images/facility washroom.jpg';
import facilityLocker2 from '../../assets/images/facility locker 2.jpg';
import facilityLocker from '../../assets/images/facility locker.jpg';
import facilityShower from '../../assets/images/facility shower.jpg';

// ─── ENTRANCE GYM PIC ─────────────────────────────────────────────────────────
import entranceGymPic from '../../assets/images/Entrance Gym pic.png';

// ─── TRAINER IMAGES (in specified order) ──────────────────────────────────────
import simonImage from '../../assets/images/Coach 5.jpg';
import edwinImage from '../../assets/images/Coach 4.jpg';
import zackImage from '../../assets/images/Coach 3.jpg';
import oliwaImage from '../../assets/images/Coach 2.jpg';
import muchiriImage from '../../assets/images/Muchiri 1.jpg';
import rashidImage from '../../assets/images/rashid.jpg';
import joeImage from '../../assets/images/joe.jpg';

// ─── TRAINER DATA ─────────────────────────────────────────────────────────────
const TRAINERS_DATA = [
  { name: "Simon", role: "Fitness Trainer", image: simonImage, description: "Passionate fitness coach with expertise in strength training and body transformation." },
  { name: "Dennis", role: "Fitness Trainer", image: edwinImage, description: "Orchestrates our dynamic class schedules, ensuring every session from HIIT to yoga delivers maximum impact." },
  { name: "Zack", role: "Fitness Trainer", image: zackImage, description: "Energetic trainer specializing in functional fitness and high-intensity workouts." },
  { name: "Oliwa", role: "Fitness Trainer", image: oliwaImage, description: "Expert in endurance training and athletic performance enhancement." },
  { name: "Rashid", role: "Fitness Trainer", image: rashidImage, description: "Dedicated fitness trainer focused on helping members build strength and confidence through personalized programs." },
  { name: "Joe", role: "Boxing & Fitness Trainer", image: joeImage, description: "Professional boxing coach teaching technique, footwork, and unstoppable cardio." },
  { name: "Muchiri", role: "Fitness Trainer", image: muchiriImage, description: "Former competitive athlete turned dedicated coach, bringing energy, expertise, and unwavering commitment to every member's success." },
];

// ─── IMAGE SETS ───────────────────────────────────────────────────────────────
const HERO_SLIDER_IMAGES = [fitneseqp12, saunaPic, steamRoom, pcfStudioOut];
const SAFETY_IMAGES = [Fitneseqp1, fitneseqp2, fitneseqp3];
const LUXURY_IMAGES = [fitneseqp4, saunaPic2, lockers1, fitneseqp5, steamRoom, lockers2];
const SAUNA_IMAGES = [saunaPic, saunaPic2, saunaPic3];
const STEAM_IMAGES = [steamRoom, steamRoom, steamRoom];
const STUDIO_IMAGES = [pcfStudioOut, studio1, pcfStudioOut];
const SPACIOUS_IMAGES = [fitneseqp6, fitneseqp7, fitneseqp8];
const LOCATION_IMAGES = [fitneseqp9, fitneseqp10, fitneseqp11];

// ─── Reusable Image Carousel ──────────────────────────────────────────────────
const Carousel = ({ images, accent = '#800020' }) => {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setCurrent(p => (p + 1) % images.length), 3500);
    return () => clearInterval(t);
  }, [images.length]);
  return (
    <div className="relative w-full h-full overflow-hidden rounded-2xl group">
      {images.map((img, i) => (
        <img key={i} src={img} alt="" className={`absolute inset-0 w-full h-full object-cover transition-all duration-700 ${i === current ? 'opacity-100 scale-100' : 'opacity-0 scale-105'}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
      <button onClick={() => setCurrent(p => (p - 1 + images.length) % images.length)}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-7 h-7 rounded-full bg-black/30 hover:bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all backdrop-blur-sm">
        <ChevronLeftIcon className="h-4 w-4 text-white" />
      </button>
      <button onClick={() => setCurrent(p => (p + 1) % images.length)}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-7 h-7 rounded-full bg-black/30 hover:bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all backdrop-blur-sm">
        <ChevronRightIcon className="h-4 w-4 text-white" />
      </button>
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1 z-10">
        {images.map((_, i) => (
          <button key={i} onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all duration-300 ${i === current ? 'w-4 bg-white' : 'w-1.5 bg-white/50'}`} />
        ))}
      </div>
    </div>
  );
};

// ─── Trainer Profile Card ──────────────────────────────────────────────────
const TrainerCard = ({ image, name, role }) => (
  <div
    className="flex-shrink-0 w-52 rounded-2xl overflow-hidden snap-start relative group bg-gray-900"
    style={{ height: '298px' }}
  >
    <img
      src={image}
      alt={name}
      className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
    />
    <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent pt-10 pb-4 px-4">
      <h4 className="text-white font-bold text-sm leading-tight" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>{name}</h4>
      <p className="text-white/60 text-xs mt-0.5">{role}</p>
    </div>
    <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-400 flex flex-col justify-end p-4">
      <h4 className="text-white font-bold text-sm" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>{name}</h4>
      <p className="text-white/60 text-xs mt-0.5">{role}</p>
    </div>
  </div>
);

// ─── Auto-Scrolling Trainer Strip ─────────────────────────────────────────────
const TrainerScrollStrip = ({ trainers }) => {
  const stripRef = useRef(null);
  const animFrameRef = useRef(null);
  const speedRef = useRef(0.6);
  const isPausedRef = useRef(false);

  const repeatedTrainers = [...trainers, ...trainers, ...trainers, ...trainers];

  useEffect(() => {
    const el = stripRef.current;
    if (!el) return;

    const singleSetWidth = el.scrollWidth / 4;
    el.scrollLeft = singleSetWidth;

    const tick = () => {
      if (!isPausedRef.current) {
        el.scrollLeft += speedRef.current;
        if (el.scrollLeft >= singleSetWidth * 3) {
          el.scrollLeft -= singleSetWidth;
        }
        if (el.scrollLeft <= 0) {
          el.scrollLeft += singleSetWidth;
        }
      }
      animFrameRef.current = requestAnimationFrame(tick);
    };

    animFrameRef.current = requestAnimationFrame(tick);

    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, []);

  const handleMouseEnter = () => { isPausedRef.current = true; };
  const handleMouseLeave = () => { isPausedRef.current = false; };

  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartScroll = useRef(0);

  const handleMouseDown = (e) => {
    isDragging.current = true;
    isPausedRef.current = true;
    dragStartX.current = e.pageX - stripRef.current.offsetLeft;
    dragStartScroll.current = stripRef.current.scrollLeft;
    stripRef.current.style.cursor = 'grabbing';
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    e.preventDefault();
    const x = e.pageX - stripRef.current.offsetLeft;
    const walk = (x - dragStartX.current) * 1.5;
    stripRef.current.scrollLeft = dragStartScroll.current - walk;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    isPausedRef.current = false;
    if (stripRef.current) stripRef.current.style.cursor = 'grab';
  };

  return (
    <div
      ref={stripRef}
      className="flex gap-4 overflow-x-auto pb-4"
      style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'touch',
        cursor: 'grab',
        userSelect: 'none',
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => { handleMouseLeave(); handleMouseUp(); }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <style>{`.trainer-strip::-webkit-scrollbar { display: none; }`}</style>
      {repeatedTrainers.map((trainer, i) => (
        <TrainerCard key={i} image={trainer.image} name={trainer.name} role={trainer.role} />
      ))}
    </div>
  );
};

// ─── Masonry Grid ─────────────────────────────────────────────────────────────
const MasonryGrid = ({ images }) => (
  <div className="grid grid-cols-3 gap-2 h-72">
    <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden">
      <img src={images[0]} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
    </div>
    <div className="rounded-xl overflow-hidden">
      <img src={images[1]} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
    </div>
    <div className="rounded-xl overflow-hidden">
      <img src={images[2]} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
    </div>
  </div>
);

// ─── Section Header ───────────────────────────────────────────────────────────
const SectionHeader = ({ badge, title, highlight, subtitle, light = false }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="text-center mb-10">
    <span className={`text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 rounded-full inline-block mb-3 ${light ? 'bg-white/20 text-white' : 'bg-primary/10 text-primary'}`}>
      {badge}
    </span>
    <h2 className={`text-3xl md:text-4xl font-black mb-3 leading-tight ${light ? 'text-white' : 'text-gray-900'}`}
      style={{ fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '-0.02em' }}>
      {title} <span style={{ color: '#800020' }}>{highlight}</span>
    </h2>
    {subtitle && <p className={`text-sm max-w-xl mx-auto leading-relaxed ${light ? 'text-white/70' : 'text-gray-500'}`}>{subtitle}</p>}
  </motion.div>
);

// ─── WHATSAPP NUMBER ─────────────────────────────────────────────────────────
const WA_NUMBER = '254117110000';

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const Facility = () => {
  return (
    <div className="min-h-screen bg-white">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
        body { font-family: 'DM Sans', sans-serif; }
      `}</style>

      {/* ── 1. HERO ── */}
      <HeroSlider customImages={HERO_SLIDER_IMAGES} />

      {/* ── FACILITY INTRO STRIP ── */}
      <section className="py-8" style={{ background: 'linear-gradient(135deg, #f9e8ec 0%, #f5d0d8 50%, #f0bbc6 100%)' }}>
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between gap-6">
            <div>
              <p className="text-sm tracking-[0.2em] uppercase mb-1 font-medium" style={{ color: '#800020' }}>Nairobi's Premier Fitness Destination</p>
              <h3 className="text-2xl font-black text-gray-900" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                WHERE EXCELLENCE MEETS <span style={{ color: '#800020' }}>WELLNESS</span>
              </h3>
            </div>
            <Link to="/pricing"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-bold text-sm text-white transition-all hover:scale-105"
              style={{ background: '#800020', boxShadow: '0 4px 20px rgba(128,0,32,0.35)' }}>
              Join Now <ArrowRightIcon className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* ── 2. SAFETY ── */}
      <section className="py-16 bg-gray-950 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'repeating-linear-gradient(45deg, #800020 0, #800020 1px, transparent 0, transparent 50%)', backgroundSize: '20px 20px' }} />
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}>
              <span className="text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 rounded-full inline-block mb-4 bg-white/10 text-white/70">Safety First</span>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-4 leading-none" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                YOUR SAFETY IS OUR <span style={{ color: '#800020' }}>NON-NEGOTIABLE</span>
              </h2>
              <p className="text-white/60 mb-6 leading-relaxed text-sm">
                Every square foot of PowerCore is engineered for your protection. From cushioned flooring that absorbs impact to emergency protocols tested monthly — we don't cut corners when it comes to keeping you safe.
              </p>
              <div className="grid grid-cols-2 gap-3 mb-8">
                {['Rubber-cushioned floors', 'AED defibrillator on-site', 'CCTV 24/7 surveillance', 'First aid certified staff', 'Equipment safety checks daily', 'Secure locker rooms'].map((f, i) => (
                  <div key={i} className="flex items-center gap-2 text-white/70 text-sm">
                    <ShieldCheckIcon className="h-4 w-4 flex-shrink-0" style={{ color: '#800020' }} />
                    <span>{f}</span>
                  </div>
                ))}
              </div>
              <Link to="/pricing" className="inline-flex items-center gap-2 px-7 py-3 rounded-full font-bold text-sm text-white transition-all hover:scale-105 group"
                style={{ background: '#800020', boxShadow: '0 4px 20px rgba(128,0,32,0.4)' }}>
                Train With Confidence <ArrowRightIcon className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}>
              <MasonryGrid images={SAFETY_IMAGES} />
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── 3. LUXURY ── */}
      <section className="py-16 bg-white">
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader badge="Premium Experience" title="LUXURY THAT" highlight="MOTIVATES" subtitle="Step into a space designed to make you feel like a champion before you even lift a weight. Every detail, from ambient lighting to premium finishes, is intentional." />
          <div className="grid lg:grid-cols-5 gap-8 items-center">
            <motion.div className="lg:col-span-3 h-80" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}>
              <Carousel images={LUXURY_IMAGES} />
            </motion.div>
            <motion.div className="lg:col-span-2 space-y-5" initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.2 }} viewport={{ once: true }}>
              {[
                { icon: '✨', title: 'Premium Finishes', desc: 'Marble accents, designer lighting and curated décor that sets the tone the moment you walk in.' },
                { icon: '🚿', title: 'Spa-Grade Showers', desc: 'Hot showers with premium amenities. Because you deserve to leave as refreshed as you arrived.' },
                { icon: '🎵', title: 'Curated Atmosphere', desc: 'Energizing sound systems and lighting zones tuned for peak performance and recovery.' },
                { icon: '🛋️', title: 'Exclusive Lounges', desc: 'Members-only relaxation zones for pre-workout prep and post-session wind-down.' },
              ].map((item, i) => (
                <div key={i} className="flex gap-4 p-4 rounded-2xl border border-gray-100 hover:border-red-100 hover:shadow-md transition-all group">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center text-lg flex-shrink-0 group-hover:scale-110 transition-transform" style={{ background: 'rgba(128,0,32,0.08)' }}>{item.icon}</div>
                  <div>
                    <h4 className="font-bold text-gray-900 text-sm mb-0.5">{item.title}</h4>
                    <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── 4. EXPERT TRAINERS — Auto-scrolling horizontal strip ── */}
      <section className="py-16 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0f0f0f 0%, #1a0008 100%)' }}>
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10" style={{ background: 'radial-gradient(circle, #800020, transparent)' }} />
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <SectionHeader
            badge="World-Class Coaching"
            title="TRAINERS WHO"
            highlight="TRANSFORM"
            subtitle="Our certified coaches don't just count reps — they rewrite your limits. Every trainer is handpicked for expertise, empathy and results."
            light
          />

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-8 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8"
          >
            <TrainerScrollStrip trainers={TRAINERS_DATA} />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6"
          >
            {[
              { icon: '🎓', stat: '100%', label: 'Certified & Licensed' },
              { icon: '💡', stat: '10+', label: 'Specializations' },
              { icon: '🏆', stat: '1000+', label: 'Members Transformed' },
              { icon: '📋', stat: 'Custom', label: 'Programs Per Member' },
            ].map((item, i) => (
              <div key={i} className="text-center p-5 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 transition-all">
                <div className="text-2xl mb-2">{item.icon}</div>
                <div className="text-xl font-black text-white mb-0.5" style={{ fontFamily: "'Barlow Condensed', sans-serif", color: '#800020' }}>{item.stat}</div>
                <div className="text-white/50 text-xs">{item.label}</div>
              </div>
            ))}
          </motion.div>

          <div className="text-center mt-8">
            <Link to="/pricing" className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold text-sm text-white transition-all hover:scale-105"
              style={{ background: '#800020', boxShadow: '0 4px 24px rgba(128,0,32,0.5)' }}>
              Get Your Personal Trainer <ArrowRightIcon className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* ── 5. SAUNA & STEAM ── */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader badge="Recovery & Wellness" title="HEAT THERAPY THAT" highlight="HEALS" subtitle="The most underrated part of your fitness journey is recovery. Our infrared sauna and steam room fast-track your healing like nothing else." />
          <div className="grid md:grid-cols-2 gap-6">
            {[
              {
                title: 'Infrared Sauna', emoji: '🌡️', color: '#F97316', images: SAUNA_IMAGES,
                tagline: 'Detox at the cellular level',
                desc: 'Our full-spectrum infrared sauna penetrates deep into muscle tissue — burning up to 600 calories in a single session while flushing toxins and accelerating recovery.',
                perks: ['Deep tissue detox', 'Muscle pain relief', 'Skin rejuvenation', 'Stress reduction'],
              },
              {
                title: 'Steam Room', emoji: '💨', color: '#06B6D4', images: STEAM_IMAGES,
                tagline: 'Breathe. Release. Restore.',
                desc: 'Eucalyptus-infused steam opens airways, clears sinuses and melts away post-workout tension. Your lungs and muscles will thank you.',
                perks: ['Respiratory health', 'Joint mobility', 'Pore cleansing', 'Circulation boost'],
              }
            ].map((item, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: i * 0.15 }} viewport={{ once: true }}
                className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
                <div className="h-56 relative overflow-hidden">
                  <Carousel images={item.images} />
                  <div className="absolute top-4 left-4 z-10">
                    <span className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{ background: item.color }}>{item.emoji} {item.title}</span>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-xs font-bold tracking-widest uppercase mb-1" style={{ color: item.color }}>{item.tagline}</p>
                  <h3 className="text-xl font-black text-gray-900 mb-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>{item.title}</h3>
                  <p className="text-gray-500 text-sm mb-4 leading-relaxed">{item.desc}</p>
                  <div className="grid grid-cols-2 gap-2">
                    {item.perks.map((p, j) => (
                      <div key={j} className="flex items-center gap-1.5 text-xs text-gray-600">
                        <div className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: item.color }} />{p}
                      </div>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          <div className="text-center mt-8">
            <Link to="/pricing" className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold text-sm text-white transition-all hover:scale-105 group"
              style={{ background: '#800020', boxShadow: '0 4px 20px rgba(128,0,32,0.35)' }}>
              Access Recovery Suite <ArrowRightIcon className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      {/* ── 6. MODERN STUDIO with studio1 image ── */}
      <section className="py-16 bg-white">
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}>
              <span className="text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 rounded-full inline-block mb-4 bg-primary/10 text-primary">Yoga Studio</span>
              <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4 leading-none" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                DEDICATED <span style={{ color: '#800020' }}>PCF STUDIO</span> FOR CLASSES
              </h2>
              <p className="text-gray-500 mb-6 text-sm leading-relaxed">
                Our dedicated PCF yoga studio is acoustically treated, climate-controlled to the perfect temperature and fitted with premium non-slip flooring. Whether you're a first-timer or a seasoned yogi, this space elevates every session.
              </p>
              <div className="space-y-3 mb-8">
                {[
                  { icon: '🌡️', text: 'Temperature-controlled at optimal heat levels' },
                  { icon: '🔇', text: 'Acoustic panels for immersive sound experience' },
                  { icon: '🧘', text: 'All-level classes from beginner to advanced' },
                  { icon: '🪞', text: 'Full-wall mirrors for form correction' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-sm text-gray-600">
                    <span className="text-base">{item.icon}</span>{item.text}
                  </div>
                ))}
              </div>
              <Link to="/activities" className="inline-flex items-center gap-2 px-7 py-3 rounded-full font-bold text-sm text-white transition-all hover:scale-105"
                style={{ background: '#800020', boxShadow: '0 4px 20px rgba(128,0,32,0.35)' }}>
                View Classes <ArrowRightIcon className="h-4 w-4" />
              </Link>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}
              className="relative h-96">
              <div className="absolute top-0 left-0 w-3/4 h-3/4 rounded-2xl overflow-hidden shadow-2xl z-10">
                <img src={studio1} alt="PCF Studio" className="w-full h-full object-cover" />
              </div>
              <div className="absolute bottom-0 right-0 w-2/3 h-2/3 rounded-2xl overflow-hidden shadow-xl z-20 border-4 border-white">
                <img src={pcfStudioOut} alt="PCF Studio" className="w-full h-full object-cover" />
              </div>
              <div className="absolute top-1/2 right-4 w-24 h-24 rounded-xl overflow-hidden shadow-lg z-30 border-2 border-white -translate-y-1/2">
                <img src={pcfStudioOut} alt="PCF Studio" className="w-full h-full object-cover" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── 7. FACILITY AMENITIES SECTION ── */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader 
            badge="Premium Amenities" 
            title="FACILITY THAT" 
            highlight="CARES" 
            subtitle="From secure lockers to spa-grade washrooms — every detail is designed for your comfort and convenience." 
          />
          
          <div className="grid md:grid-cols-3 gap-8">
            {/* Lockers Card */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all group"
            >
              <div className="h-64 relative overflow-hidden">
                <Carousel images={[facilityLocker, facilityLocker2]} />
                <div className="absolute top-4 left-4 z-10">
                  <span className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{ background: '#800020' }}>🔒 Secure Lockers</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-black text-gray-900 mb-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>Premium Lockers</h3>
                <p className="text-gray-500 text-sm mb-4 leading-relaxed">
                  Spacious, secure storage for your belongings. Code-based or key access — you choose. Fit everything from gym bags to work laptops.
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">🔐 Digital Locks</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">📏 Extra Large</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">🧼 Daily Sanitized</span>
                </div>
              </div>
            </motion.div>

            {/* Washrooms Card */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all group"
            >
              <div className="h-64 relative overflow-hidden">
                <Carousel images={[facilityWashroom]} />
                <div className="absolute top-4 left-4 z-10">
                  <span className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{ background: '#800020' }}>🚻 Premium Washrooms</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-black text-gray-900 mb-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>Spa-Grade Washrooms</h3>
                <p className="text-gray-500 text-sm mb-4 leading-relaxed">
                  Immaculately maintained washrooms with premium fixtures, constant cleaning service, and full accessibility.
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">✨ Touchless Faucets</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">🧴 Premium Soaps</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">🔄 Hourly Cleaning</span>
                </div>
              </div>
            </motion.div>

            {/* Showers Card */}
            <motion.div 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all group"
            >
              <div className="h-64 relative overflow-hidden">
                <Carousel images={[facilityShower]} />
                <div className="absolute top-4 left-4 z-10">
                  <span className="px-3 py-1 rounded-full text-xs font-bold text-white" style={{ background: '#800020' }}>🚿 Luxury Showers</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-black text-gray-900 mb-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>Spa-Grade Showers</h3>
                <p className="text-gray-500 text-sm mb-4 leading-relaxed">
                  Hot, powerful showers with premium shampoo, conditioner and body wash. The perfect post-workout refresh.
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">💧 High Pressure</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">🌡️ Instant Hot Water</span>
                  <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">🧴 Premium Products</span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── 8. SPACIOUS ── */}
      <section className="py-16 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #800020 0%, #3d0010 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px), radial-gradient(circle at 80% 50%, white 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <SectionHeader badge="Space & Freedom" title="ROOM TO" highlight="BREATHE" subtitle="Cramped gyms kill motivation. We built PowerCore with one principle — you should never feel restricted. Expansive zones, wide aisles, dedicated spaces for every discipline." light />
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            {[
              { num: '8,000', unit: 'sq ft', label: 'Total Floor Space' },
              { num: '200+', unit: 'pieces', label: 'Equipment Units' },
              { num: '6', unit: 'zones', label: 'Dedicated Areas' },
              { num: '0', unit: 'wait time', label: 'Off-Peak Guarantee' },
            ].map((s, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: i * 0.1 }} viewport={{ once: true }}
                className="text-center p-5 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20">
                <div className="text-4xl font-black text-white leading-none" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>{s.num}</div>
                <div className="text-white/50 text-xs mt-0.5 mb-1">{s.unit}</div>
                <div className="text-white/70 text-xs font-medium">{s.label}</div>
              </motion.div>
            ))}
          </div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}>
            <MasonryGrid images={SPACIOUS_IMAGES} />
          </motion.div>
          <div className="text-center mt-8">
            <Link to="/pricing" className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-bold text-sm transition-all hover:scale-105 bg-white group"
              style={{ color: '#800020' }}>
              Claim Your Space <ArrowRightIcon className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>

      {/* ── 9. LOCATION ── */}
      <section className="py-16 bg-gray-950">
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}
              className="order-2 lg:order-1">
              <div className="relative rounded-3xl overflow-hidden h-80 bg-gray-800 border border-white/10">
                <img src={LOCATION_IMAGES[0]} alt="Southfield Mall" className="w-full h-full object-cover opacity-60" />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center mb-3" style={{ background: '#800020' }}>
                    <MapPinIcon className="h-6 w-6 text-white" />
                  </div>
                  <h4 className="text-white font-black text-lg mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>SOUTHFIELD MALL</h4>
                  <p className="text-white/60 text-sm">Along Nairobi Express Highway, Nairobi</p>
                  <a href="https://maps.google.com" target="_blank" rel="noreferrer"
                    className="mt-4 inline-flex items-center gap-2 px-5 py-2 rounded-full text-xs font-bold text-white border border-white/30 hover:bg-white hover:text-gray-900 transition-all">
                    Open in Maps <ArrowRightIcon className="h-3 w-3" />
                  </a>
                </div>
              </div>
            </motion.div>
            <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}
              className="order-1 lg:order-2">
              <span className="text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 rounded-full inline-block mb-4 bg-white/10 text-white/70">Prime Location</span>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-4 leading-none" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                STRATEGICALLY PLACED FOR <span style={{ color: '#800020' }}>YOUR CONVENIENCE</span>
              </h2>
              <p className="text-white/60 mb-6 text-sm leading-relaxed">
                No detours. No excuses. PowerCore is nestled inside <strong className="text-white">Southfield Mall</strong> along the <strong className="text-white">Nairobi Express Highway</strong> — making it the most accessible gym in the city whether you're commuting, shopping or just passing through.
              </p>
              <div className="space-y-3 mb-8">
                {[
                  { icon: '🚗', text: 'Ample parking space at Southfield Mall' },
                  { icon: '💰', text: 'FREE 2 hours parking, then KES 100 per hour' },
                  { icon: '🚌', text: 'Matatu & bus routes stop right outside' },
                  { icon: '🏬', text: 'Combined shopping & fitness in one trip' },
                  { icon: '🛣️', text: 'Direct access from Nairobi Express Highway' },
                  { icon: '⏱️', text: 'Open from 5AM — no schedule conflicts' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-sm text-white/60">
                    <span className="text-base">{item.icon}</span>{item.text}
                  </div>
                ))}
              </div>
              <Link to="/pricing" className="inline-flex items-center gap-2 px-7 py-3 rounded-full font-bold text-sm text-white transition-all hover:scale-105"
                style={{ background: '#800020', boxShadow: '0 4px 20px rgba(128,0,32,0.4)' }}>
                Visit Us Today <ArrowRightIcon className="h-4 w-4" />
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ── 10. FINAL CTA ── */}
      <section className="py-16 relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #800020 0%, #3d0010 100%)' }}>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full filter blur-3xl" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full filter blur-3xl" />
        </div>
        <div className="container-custom max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}>
            <span className="text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 rounded-full inline-block mb-4 bg-white/20 text-white/80">Limited Spots Available</span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 leading-none" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
              READY TO START YOUR <span className="text-yellow-400">JOURNEY?</span>
            </h2>
            <p className="text-white/80 mb-8 max-w-xl mx-auto text-sm leading-relaxed">
              Join PowerCore today and transform your life. No contracts. No excuses. Just results.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/pricing"
                className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full font-black text-sm text-gray-900 bg-white transition-all hover:scale-105 hover:shadow-2xl"
                style={{ letterSpacing: '0.06em' }}>
                View Pricing & Join <ArrowRightIcon className="h-4 w-4" />
              </Link>
              <a href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hi PowerCore! I\'d like to book a tour of your facility.')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full font-bold text-sm text-white border-2 border-white/40 hover:bg-white/10 transition-all"
                style={{ letterSpacing: '0.06em' }}>
                Chat on WhatsApp
              </a>
            </div>
          </motion.div>
        </div>
      </section>

    </div>
  );
};

export default Facility;